exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-3c945baa]{border-radius:8px;border:1px solid #becdd7;-webkit-box-shadow:0 2px 8px 0 rgba(0,0,0,.1);box-shadow:0 2px 8px 0 rgba(0,0,0,.1);height:40px;padding:16px}.label[data-v-3c945baa]{font-size:.8125rem;color:#fff;color:#879baa}.content[data-v-3c945baa],.label[data-v-3c945baa]{font-family:SiemensSansGlobalCC-Roman,Helvetica Neue,Helvetica,sans-serif}.content[data-v-3c945baa]{position:relative;padding:10px 0 0 20px;font-size:.875rem;line-height:1rem;color:#00646e}.box-fill[data-v-3c945baa]{background:rgba(190,205,215,.2)}", ""]);

// exports
